import { Modal } from "antd";
import FormPagarConta from "./FormPagarConta";
import usePagarConta from "features/conta/hooks/usePagarConta";
import { PagarContaForm, ContaAnexo } from "features/conta/typings";
import { OperacaoEnum } from "resources/enums/conta";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useInvalidateQuery } from "infra/packages/react-query/index";
interface ModalFormPagarContaProps {
  contaId: string;
  operacao: OperacaoEnum;
  isOpen: boolean;
  onClose: () => any;
  onSaved?: () => any;
  dataPagamentoPadraoIgualADataVencimento?: boolean;
  refetch?: () => any;
}

function ModalFormPagarConta({
  contaId,
  isOpen,
  operacao,
  onClose,
  onSaved,
  refetch,
  dataPagamentoPadraoIgualADataVencimento,
}: ModalFormPagarContaProps) {
  const { mutate: pagarConta, isLoading } = usePagarConta();
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const onError = (err: unknown) => showErrorAxios(err);

  const onPagarConta = (data: PagarContaForm) => {
    const _data: PagarContaForm = {
      ...data,
      anexos: (data.files?.filter((f) => !(f instanceof File)) ??
        []) as ContaAnexo[],
    };
    delete _data.files;

    pagarConta(_data, {
      onSuccess: () => {
        setTimeout(() => {
          onSaved?.();
        }, 200);
        const invalidateDetalhe = () => {
          if (contaId) {
            doInvalidateQueryWithStringKey(`/v1/conta/${contaId}/completa`);
          }
        };
        showSuccess().then(({ isConfirmed }) => {
          if (isConfirmed) {
            onClose();
            refetch?.();
          }
          invalidateDetalhe();
        });
      },
      onError,
    });
  };

  return (
    <Modal
      centered
      visible={isOpen}
      footer={null}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width={"min(760px, 80vw)"}
      bodyStyle={{
        maxHeight: "85vh",
        overflow: "auto",
        paddingBottom: 16,
      }}
    >
      <FormPagarConta
        visible={isOpen}
        contaId={contaId}
        operacao={operacao}
        onSave={onPagarConta}
        onClose={onClose}
        isLoadingSave={isLoading}
        dataPagamentoPadraoIgualADataVencimento={
          dataPagamentoPadraoIgualADataVencimento
        }
      />
    </Modal>
  );
}

export default ModalFormPagarConta;
